import React from 'react';

import HealthList from 'src/features/motion/HealthList';
import HealthMachineDetail from 'src/features/motion/HealthMachineDetail';
import Map from 'src/features/motion/Map';
import StatusBar from 'src/features/motion/StatusBar';
import styled from 'styled-components';

const MotionStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

export default function Motion() {
  const [activeMarker, setActiveMarker] = React.useState<undefined | number>(
    undefined,
  );

  const onMarkerClick = React.useCallback((marker: any) => {
    setActiveMarker(marker);
  }, []);

  return (
    <MotionStyled>
      <Map onMarkerClick={onMarkerClick} />
      <HealthList />
      <StatusBar />
      <HealthMachineDetail
        healthId={activeMarker}
        onClose={() => {
          setActiveMarker(undefined);
        }}
        open={Boolean(activeMarker)}
      />
    </MotionStyled>
  );
}
